module.exports = __webpack_public_path__ + "static/media/class_job_006.106a761e.svg";